/**
 * LES STATISTIQUES DES NC, CÔTÉ ÉCRAN — module PUR (RQ, 13/10/2026, lot 4).
 *
 * L'analyse fine du registre : où sont les écarts (nature), qui les trouve (le
 * laboratoire ou l'extérieur), et ce qui SE RÉPÈTE — même problème, même
 * appareil, même correspondant. ⚠️ Même règle que le moteur pour la revue de
 * direction (`backend/src/nc-statistiques.ts`) : une récurrence = au moins deux
 * NC sur la fenêtre, une valeur vide n'en est jamais une.
 * Testé depuis `backend/tests/front-stats-nc.test.js`.
 */

export interface NcPourStats {
  probleme?: string | null; equipementCode?: string | null; correspondantCode?: string | null;
  titre?: string | null; dateDeclaration?: string | null; dateDetection?: string | null;
}

const txt = (v: unknown) => String(v ?? '').trim();

/** Les NC déclarées (ou détectées) dans les `jours` qui précèdent `aujourdhui` (AAAA-MM-JJ). */
export function depuis<T extends NcPourStats>(ncs: readonly T[], aujourdhui: string, jours = 365): T[] {
  const fin = new Date(`${aujourdhui}T00:00:00Z`).getTime();
  return ncs.filter((n) => {
    const d = txt(n.dateDeclaration || n.dateDetection).slice(0, 10);
    if (!d) return false;
    const t = new Date(`${d}T00:00:00Z`).getTime();
    return t <= fin && t > fin - jours * 86400000;
  });
}

/** Les valeurs d'un champ revenues au moins `min` fois, de la plus fréquente à la moins. */
export function recurrences(ncs: readonly NcPourStats[], champ: 'probleme' | 'equipementCode' | 'correspondantCode', min = 2):
  { valeur: string; n: number; exemple: string }[] {
  const m = new Map<string, { n: number; exemple: string }>();
  for (const nc of ncs) {
    const v = txt(nc[champ]);
    if (!v) continue;
    const e = m.get(v) || { n: 0, exemple: txt(nc.titre) };
    e.n += 1;
    m.set(v, e);
  }
  return [...m.entries()].filter(([, e]) => e.n >= min)
    .map(([valeur, e]) => ({ valeur, n: e.n, exemple: e.exemple }))
    .sort((a, b) => b.n - a.n || a.valeur.localeCompare(b.valeur));
}
